<template>
    <div class="bg-zinc-100 pt-20 ">
        <main class="min-h-screen">
            <slot />
        </main>
    </div>
</template>

<script>
// check if user is authenticated
// redirect to login page to dashboard page if user is authenticated
</script>